import { Snotify } from 'vue-snotify'

export interface INotificationService {
  snotify: any
  success(message: string): void
  created(message: string): void
  warning(message: string): void
  error(message: string): void
  info(message: string): void
  loading(message: string): void
}

export default class NotificationService implements INotificationService {
  public snotify: any

  constructor(snotify: any) {
    this.snotify = snotify
  }

  public success(message: string): void {
    this.snotify.success(message, {
      showProgressBar: true,
      pauseOnHover: true,
      closeOnClick: false,
      timeout: 2000,
    })
  }

  public created(message: string): void {
    this.snotify.success(message, {
      showProgressBar: true,
      pauseOnHover: true,
      closeOnClick: false,
      timeout: 10000,
    })
  }
  public warning(message: string): void {
    this.snotify.warning(message, {
      showProgressBar: true,
      pauseOnHover: true,
      closeOnClick: false,
      // changed for delete a role
    })
  }

  public error(message: string): void {
    this.snotify.error(message, {
      showProgressBar: true,
      closeOnClick: true,
      timeout: 5000,
    })
  }

  public info(message: string): void {
    this.snotify.info(message, {
      showProgressBar: true,
      pauseOnHover: true,
      closeOnClick: false,
      timeout: 5000,
    })
  }

  public loading(message: string): void {
    this.snotify.async(message, {
      closeOnClick: false,
      type: 'warning',
    })
  }
  // public loading(message: string): void {
  //   this.snotify.info(message, {
  //     closeOnClick: false,
  //     timeout: 120000,
  //     html:'<v-progress-circular></v-progress-circular>',
  //   })
  // }
}
